"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = findEntities;
function findEntities(entityType) {
    return function findEntitiesFunc(contentBlock, callback, contentState) {
        contentBlock.findEntityRanges(function (character) {
            var entityKey = character.getEntity();
            return entityKey !== null && contentState.getEntity(entityKey).getType() === entityType;
        }, callback);
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-utils@0.1.0@rc-editor-utils/lib/findEntity.js
// module id = 120
// module chunks = 0 1 2